import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { AdminPage } from './AdminPage';
import { EventsSubpage } from './Events/EventsSubpage';
import { MathplanSubpage } from './Mathplan/MathplanSubpage';
import { OrganizationsSubpage } from './Organizations/OrganizationsSubpage';
import { SubstitutionsSubpage } from './Substitutions/SubstitutionsSubpage';

export const adminRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      element: <AdminPage />,
      index: true,
    },
    {
      path: t('routes.organizations.slug'),
      element: <OrganizationsSubpage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.organizations.slug')}`,
          title: t('routes.organizations.title'),
        }),
      },
    },
    {
      path: t('routes.mathplan.slug'),
      element: <MathplanSubpage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.mathplan.slug')}`,
          title: t('routes.mathplan.title'),
        }),
      },
    },
    {
      path: t('routes.events.slug'),
      element: <EventsSubpage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.events.slug')}`,
          title: t('routes.events.title'),
        }),
      },
    },
    {
      path: t('routes.substitutions.slug'),
      element: <SubstitutionsSubpage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutions.slug')}`,
          title: t('routes.substitutions.title'),
        }),
      },
    },
  ];
};
